import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faThumbsUp, faCheckCircle, faStore } from '@fortawesome/free-solid-svg-icons';
import { reviewsAPI } from '../services/api';
import './ReviewCard.css';

const ReviewCard = ({ review, onHelpful }) => {
  const [helpfulCount, setHelpfulCount] = useState(review.helpful || 0);
  const [hasVoted, setHasVoted] = useState(false);

  const handleVote = async () => {
    if (hasVoted) return;

    try {
      await reviewsAPI.voteReview(review.id || review._id, true);
      setHelpfulCount(prev => prev + 1);
      setHasVoted(true);
      if (onHelpful) onHelpful();
    } catch (error) {
    }
  };

  const renderStars = (rating) => {
    return (
      <div className="AutoboyExpress-review-stars">
        {[1, 2, 3, 4, 5].map((star) => (
          <FontAwesomeIcon
            key={star}
            icon={faStar}
            className={star <= rating ? 'star-filled' : 'star-empty'}
          />
        ))}
      </div>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Recently';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="AutoboyExpress-review-card">
      <div className="AutoboyExpress-review-header">
        <div className="AutoboyExpress-review-user">
          <div className="AutoboyExpress-review-avatar">
            {review.user?.avatar ? (
              <img src={review.user.avatar} alt={review.user?.name || 'User'} />
            ) : (
              <div className="AutoboyExpress-review-avatar-placeholder">
                {(review.user?.name || 'U').charAt(0).toUpperCase()}
              </div>
            )}
          </div>
          <div className="AutoboyExpress-review-user-info">
            <div className="AutoboyExpress-review-name-row">
              <span className="AutoboyExpress-review-name">{review.user?.name || 'Anonymous'}</span>
              {review.is_verified_purchase && (
                <span className="AutoboyExpress-review-verified">
                  <FontAwesomeIcon icon={faCheckCircle} />
                  Verified Purchase
                </span>
              )}
            </div>
            {renderStars(review.rating)}
          </div>
        </div>
        <span className="AutoboyExpress-review-date">
          {formatDate(review.created_at || review.createdAt)}
        </span>
      </div>

      {review.title && (
        <h4 className="AutoboyExpress-review-title">{review.title}</h4>
      )}

      <p className="AutoboyExpress-review-comment">{review.comment}</p>

      {review.images && review.images.length > 0 && (
        <div className="AutoboyExpress-review-images">
          {review.images.slice(0, 3).map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`Review ${idx + 1}`}
              className="AutoboyExpress-review-image"
            />
          ))}
        </div>
      )}

      <div className="AutoboyExpress-review-footer">
        <button
          className={`AutoboyExpress-review-helpful-btn ${hasVoted ? 'voted' : ''}`}
          onClick={handleVote}
          disabled={hasVoted}
        >
          <FontAwesomeIcon icon={faThumbsUp} />
          Helpful {helpfulCount > 0 ? `(${helpfulCount})` : ''}
        </button>
      </div>

      {review.seller_response && (
        <div className="AutoboyExpress-review-seller-response">
          <div className="AutoboyExpress-seller-response-header">
            <FontAwesomeIcon icon={faStore} />
            <span>Seller Response</span>
          </div>
          <p className="AutoboyExpress-seller-response-message">{review.seller_response.message}</p>
          <span className="AutoboyExpress-seller-response-date">
            {formatDate(review.seller_response.created_at || review.seller_response.createdAt)}
          </span>
        </div>
      )}
    </div>
  );
};

export default ReviewCard;
